import { R as slot, P as pop, N as push } from "../../../chunks/index.js";
import "../../../chunks/client.js";
function _layout($$payload, $$props) {
  push();
  $$payload.out += `<!---->`;
  slot($$payload, $$props, "default", {});
  $$payload.out += `<!---->`;
  pop();
}
export {
  _layout as default
};
